"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./divider.css");

exports.default = {
  divider: 'pf-c-divider',
  modifiers: {
    'vertical': 'pf-m-vertical',
    'insetNone': 'pf-m-inset-none',
    'insetSm': 'pf-m-inset-sm',
    'insetMd': 'pf-m-inset-md',
    'insetLg': 'pf-m-inset-lg',
    'insetXl': 'pf-m-inset-xl',
    'inset_2xl': 'pf-m-inset-2xl',
    'inset_3xl': 'pf-m-inset-3xl',
    'insetNoneOnSm': 'pf-m-inset-none-on-sm',
    'insetSmOnSm': 'pf-m-inset-sm-on-sm',
    'insetMdOnSm': 'pf-m-inset-md-on-sm',
    'insetLgOnSm': 'pf-m-inset-lg-on-sm',
    'insetXlOnSm': 'pf-m-inset-xl-on-sm',
    'inset_2xlOnSm': 'pf-m-inset-2xl-on-sm',
    'inset_3xlOnSm': 'pf-m-inset-3xl-on-sm',
    'insetNoneOnMd': 'pf-m-inset-none-on-md',
    'insetSmOnMd': 'pf-m-inset-sm-on-md',
    'insetMdOnMd': 'pf-m-inset-md-on-md',
    'insetLgOnMd': 'pf-m-inset-lg-on-md',
    'insetXlOnMd': 'pf-m-inset-xl-on-md',
    'inset_2xlOnMd': 'pf-m-inset-2xl-on-md',
    'inset_3xlOnMd': 'pf-m-inset-3xl-on-md',
    'insetNoneOnLg': 'pf-m-inset-none-on-lg',
    'insetSmOnLg': 'pf-m-inset-sm-on-lg',
    'insetMdOnLg': 'pf-m-inset-md-on-lg',
    'insetLgOnLg': 'pf-m-inset-lg-on-lg',
    'insetXlOnLg': 'pf-m-inset-xl-on-lg',
    'inset_2xlOnLg': 'pf-m-inset-2xl-on-lg',
    'inset_3xlOnLg': 'pf-m-inset-3xl-on-lg',
    'insetNoneOnXl': 'pf-m-inset-none-on-xl',
    'insetSmOnXl': 'pf-m-inset-sm-on-xl',
    'insetMdOnXl': 'pf-m-inset-md-on-xl',
    'insetLgOnXl': 'pf-m-inset-lg-on-xl',
    'insetXlOnXl': 'pf-m-inset-xl-on-xl',
    'inset_2xlOnXl': 'pf-m-inset-2xl-on-xl',
    'inset_3xlOnXl': 'pf-m-inset-3xl-on-xl',
    'insetNoneOn_2xl': 'pf-m-inset-none-on-2xl',
    'insetSmOn_2xl': 'pf-m-inset-sm-on-2xl',
    'insetMdOn_2xl': 'pf-m-inset-md-on-2xl',
    'insetLgOn_2xl': 'pf-m-inset-lg-on-2xl',
    'insetXlOn_2xl': 'pf-m-inset-xl-on-2xl',
    'inset_2xlOn_2xl': 'pf-m-inset-2xl-on-2xl',
    'inset_3xlOn_2xl': 'pf-m-inset-3xl-on-2xl'
  }
};